import axios from 'axios';
import showToaster from '../showToaster';
import { getShortPushNotification } from './getShortPushNotification';

export async function sendAdvancedNotifications(content, targetingData) {
    try {
        // Trim message if needed
        let processedContent = { ...content };
        if (content.message) {
            const trimContent = await getShortPushNotification(content.message);
            processedContent.message = trimContent || content.message;
        }

        const requestBody = {
            content: processedContent,
            targeting: targetingData
        };

        const response = await axios.post('http://localhost:4000/advanced-push-notification', requestBody, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            withCredentials: true
        });

        const { status, errorMessage, deliveredCount, targetedUsers } = response.data;

        if (status === 200) {
            showToaster({ 
                messageId: 'sendNotification', 
                toasterType: 'success',
                message: `Notification sent to ${deliveredCount} users successfully!`
            });
        }

        return {
            status,
            errorMessage,
            deliveredCount,
            targetedUsers
        };

    } catch (error) {
        console.error('Error in sendAdvancedNotifications:', error);
        
        showToaster({ 
            messageId: 'sendNotificationError', 
            toasterType: 'error',
            message: 'Failed to send notification. Please try again.'
        });

        return {
            status: 400,
            errorMessage: error.response && error.response.data && error.response.data.errorMessage ? error.response.data.errorMessage : error.message
        };
    }
}

export default {
    sendAdvancedNotifications
};